import Main from './ui/main/Main';

export default Main;
